import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Ce qu'une requête représente pour Matomo, déclaré là où le geste métier est
 * connu (le composant), et non deviné depuis l'URL : une même URL sert à un
 * brouillon enregistré automatiquement comme à une validation définitive.
 *
 * - `'ignorer'` : écriture automatique (sauvegarde de fond, chronomètre…), rien ne remonte ;
 * - objet : libellés métier, comptés seulement si la requête réussit.
 */
export type MesureMatomo = 'ignorer' | {
    /** Verbe métier ; à défaut, celui du plan (`matomo-plan.ts`). */
    action?: string;
    /** Objet ; à défaut, celui du plan. */
    nom?: string;
};

export const MESURE_MATOMO = new HttpContextToken<MesureMatomo | null>(() => null);

/**
 * Options HttpClient / ApiService portant la mesure. Se combine avec d'autres
 * options : `mesureMatomo({ action: 'Valider' }, sansToastErreur())`.
 */
export function mesureMatomo(mesure: MesureMatomo, options: { context?: HttpContext } = {}): { context: HttpContext } {
    return { ...options, context: (options.context ?? new HttpContext()).set(MESURE_MATOMO, mesure) };
}
